(function () {
  if (customElements.get('ce-toast-maker') !== undefined) {
    return;
  }

  class ToastMaker extends HTMLParsedElement {
    constructor() {
      super();

      this.selectors = {
        toaster: 'ce-toaster',
      };

      this.elements = null;
    }

    async parsedCallback() {
      await customElements.whenDefined('ce-toaster');

      this.elements = {
        toaster: document.querySelector(this.selectors.toaster),
      };

      const type = this.getAttribute('type');
      const content = this.textContent;

      if (this.hasAttribute('duration')) {
        const duration = parseInt(this.getAttribute('duration'));
        this.elements.toaster.makeToast(type, content, duration);
      } else {
        this.elements.toaster.makeToast(type, content);
      }
    }
  }

  customElements.define('ce-toast-maker', ToastMaker);
})();
